<template>
    <div style="width: auto; height: auto; background: #514773;">
        <v-container fluid>
            <v-row style="height: 100vh; " justify="center" align="center">
                <v-card
                    color="white"
                    :width="this.$vuetify.breakpoint.xs||this.$vuetify.breakpoint.sm||this.$vuetify.breakpoint.md?'90vw':'40vw'"
                    :height="this.$vuetify.breakpoint.xs||this.$vuetify.breakpoint.sm||this.$vuetify.breakpoint.md?'80vh':'65vh'"
                    rounded
                    style="border-radius:1vw !important;"
                >
                    <v-container fluid>
                        <v-row class="row-card">
                            <v-col cols="2">
                                   <v-img
                                    :src="require('../../assets/img/effects/corner-badge.svg')"
                                    elevation="6"
                                    contain
                                    :max-width="this.$vuetify.breakpoint.xs||this.$vuetify.breakpoint.sm||this.$vuetify.breakpoint.md?'20vw':'7vw'"
                                    :width="this.$vuetify.breakpoint.xs||this.$vuetify.breakpoint.sm||this.$vuetify.breakpoint.md?'20vw':'7vw'"
                                    :max-height="this.$vuetify.breakpoint.xs||this.$vuetify.breakpoint.sm||this.$vuetify.breakpoint.md?'20vw':'8vw'"
                                    :height="this.$vuetify.breakpoint.xs||this.$vuetify.breakpoint.sm||this.$vuetify.breakpoint.md?'20vw':'8vw'"
                                    class="card-number"
                                >
                                    <h1 class="number-icon-card">{{statusCard}}</h1>
                                </v-img>
                            </v-col>
                            <v-col cols="8">
                                <p class="title-content">{{titleContent}}</p>
                                <div :class="textContentLength">
                                    <p class="py-12" v-if="statusCard === 3"></p>
                                    <p class="text-content-two" v-if="textContent.length===3">{{textContent[0]}}</p>
                                    <p class="text-content-two" v-if="textContent.length===3">{{textContent[1]}}</p>
                                    <p class="text-content-two" v-if="textContent.length===3">{{textContent[2]}}</p>
                                    <p class="text-content" v-else>{{textContent}}</p>
                                </div>
                                <v-btn
                                    data-cy="continue-button-pre-message-card"
                                    rounded
                                    large
                                    color="#FF6F3A"
                                    dark
                                    :width="this.$vuetify.breakpoint.xs||this.$vuetify.breakpoint.sm||this.$vuetify.breakpoint.md?'40vw':'12vw'"
                                    :height="this.$vuetify.breakpoint.xs||this.$vuetify.breakpoint.sm||this.$vuetify.breakpoint.md?'10vw':'2.5vw'"
                                    class="button-3"
                                    style="margin-top: 20px"
                                    @click="startChallenge"
                                >{{$t('initialTour.continue')}}</v-btn>

                            </v-col>
                            <v-col cols="2">
                                <v-row class="row-right-icon" align="start">
                                    <v-img
                                        :src="require('../../assets/img/bees/bee004.svg')"
                                        elevation="6"
                                        contain
                                        :max-width="this.$vuetify.breakpoint.xs||this.$vuetify.breakpoint.sm||this.$vuetify.breakpoint.md?'20vw':'7vw'"
                                        :width="this.$vuetify.breakpoint.xs||this.$vuetify.breakpoint.sm||this.$vuetify.breakpoint.md?'20vw':'7vw'"
                                        :max-height="this.$vuetify.breakpoint.xs||this.$vuetify.breakpoint.sm||this.$vuetify.breakpoint.md?'20vw':'8vw'"
                                        :height="this.$vuetify.breakpoint.xs||this.$vuetify.breakpoint.sm||this.$vuetify.breakpoint.md?'20vw':'8vw'"
                                        :class="statusCard !== 1 ? 'display-hide' : ''"
                                        style="position: relative; bottom: 8vh; left: 2vw"
                                    ></v-img>
                                </v-row>
                                <v-row class="row-right-icon" align="end">
                                    <v-img
                                        :src="require('../../assets/img/bees/bee005.svg')"
                                        elevation="6"
                                        contain
                                        :max-width="this.$vuetify.breakpoint.xs||this.$vuetify.breakpoint.sm||this.$vuetify.breakpoint.md?'20vw':'7vw'"
                                        :width="this.$vuetify.breakpoint.xs||this.$vuetify.breakpoint.sm||this.$vuetify.breakpoint.md?'20vw':'7vw'"
                                        :max-height="this.$vuetify.breakpoint.xs||this.$vuetify.breakpoint.sm||this.$vuetify.breakpoint.md?'20vw':'8vw'"
                                        :height="this.$vuetify.breakpoint.xs||this.$vuetify.breakpoint.sm||this.$vuetify.breakpoint.md?'20vw':'8vw'"
                                        :class="statusCard !== 1 ? 'display-hide' : ''"
                                        style="position: relative; top: 4vh; right: 0"
                                    ></v-img>
                                    <v-img
                                        :src="require('../../assets/img/bees/bee003.svg')"
                                        elevation="6"
                                        contain
                                        :max-width="this.$vuetify.breakpoint.xs||this.$vuetify.breakpoint.sm||this.$vuetify.breakpoint.md?'20vw':'7vw'"
                                        :width="this.$vuetify.breakpoint.xs||this.$vuetify.breakpoint.sm||this.$vuetify.breakpoint.md?'20vw':'7vw'"
                                        :max-height="this.$vuetify.breakpoint.xs||this.$vuetify.breakpoint.sm||this.$vuetify.breakpoint.md?'20vw':'8vw'"
                                        :height="this.$vuetify.breakpoint.xs||this.$vuetify.breakpoint.sm||this.$vuetify.breakpoint.md?'20vw':'8vw'"
                                        :class="statusCard !== 2 ? 'display-hide' : ''"
                                        style="position: relative; bottom: 3vh; right: 2vw"
                                    ></v-img>
                                    <v-img
                                        src="/img/user/beecoin-3.svg"
                                        :max-width="this.$vuetify.breakpoint.xs||this.$vuetify.breakpoint.sm||this.$vuetify.breakpoint.md?'20vw':'6vw'"
                                        :width="this.$vuetify.breakpoint.xs||this.$vuetify.breakpoint.sm||this.$vuetify.breakpoint.md?'20vw':'6vw'"
                                        :max-height="this.$vuetify.breakpoint.xs||this.$vuetify.breakpoint.sm||this.$vuetify.breakpoint.md?'20vw':'6vw'"
                                        :height="this.$vuetify.breakpoint.xs||this.$vuetify.breakpoint.sm||this.$vuetify.breakpoint.md?'20vw':'6vw'"
                                        :class="'beecoin-icon-1 ' + (statusCard !== 3 ? 'display-hide' : '')"
                                    ></v-img>
                                    <v-img
                                        src="/img/user/beecoin-3.svg"
                                        :max-width="this.$vuetify.breakpoint.xs||this.$vuetify.breakpoint.sm||this.$vuetify.breakpoint.md?'40vw':'11vw'"
                                        :width="this.$vuetify.breakpoint.xs||this.$vuetify.breakpoint.sm||this.$vuetify.breakpoint.md?'40vw':'11vw'"
                                        :max-height="this.$vuetify.breakpoint.xs||this.$vuetify.breakpoint.sm||this.$vuetify.breakpoint.md?'40vw':'11vw'"
                                        :height="this.$vuetify.breakpoint.xs||this.$vuetify.breakpoint.sm||this.$vuetify.breakpoint.md?'40vw':'11vw'"
                                        :class="'beecoin-icon-2 ' + (statusCard !== 3 ? 'display-hide' : '')"
                                    ></v-img>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card>
            </v-row>
        </v-container>
    </div>
</template>
<script>
import { mapActions } from 'vuex'

export default {
    data(){
        return {
            statusCard: 1,
        }
    },
    computed: {
        titleContent() {
            if (this.statusCard === 1) {
                return this.$t('challenge.initial_card_title_1');
            }
            if (this.statusCard === 2) {
                return this.$t('challenge.initial_card_title_2');
            }
            return this.$t('challenge.initial_card_title_3');
        },
        textContent() {
            if (this.statusCard === 1) {
                return this.$t('challenge.initial_card_text_1');
            }
            if (this.statusCard === 2) {
                return [
                    this.$t('challenge.initial_card_text_2[0]'),
                    this.$t('challenge.initial_card_text_2[1]'),
                    this.$t('challenge.initial_card_text_2[2]')
                ];
            }
            return this.$t('challenge.initial_card_text_3');
        },
        textContentLength() {
            if (this.statusCard === 1) {
                return 'container-text-1';
            }
            if (this.statusCard === 2) {
                return 'container-text-2';
            }
            return 'container-text-3';
        }
    },
    methods:{
        ...mapActions('challenge', [
            'setChallengeStage',
        ]),
        startChallenge() {
            this.setChallengeStage('prizeBreakdown');
        }
    }
}
</script>
<style scoped>

.display-hide {
    display: none;
}

.row-card {
    height: 50vh;
}

.card-number {
    align-items: center;
    position: relative;
    right: 6vh;
    bottom: 6vh;
}

.title-content {
    text-align: initial;
    margin-top: 5%;
    margin-bottom: 3%;
    font-size: 2vw;
    color: #514773;
}

.text-content {
    text-align: initial;
    margin-bottom: 1%;
    font-size: 1.2vw;
    color: #514773;
}

.text-content-two {
    text-align: initial;
    margin-bottom: 1%;
    font-size: 1vw;
    color: #514773;
}

.container-text-1 {
    width: 20vw;
}

.container-text-2 {
    width: 25vw;
}

.container-text-3 {
    width: 30vw;
}

.button-next-1-text {
    color: white;
    font-size: 1vw;
    margin-bottom: 0;
}

.button-next-2-text-1 {
    color: white;
    font-size: 1vw;
    margin-bottom: 0;
}

.button-next-2-text-2 {
    color: #ff6f3a;
    font-size: 1vw;
    margin-bottom: 0;
}

.button-3 {
    text-transform: none;
    font-size: 0.7vw;
    font-weight: bold;
}

.number-icon-card {
    color: #ff6f3a;
    font-size: 3vw;
}

.row-right-icon {
    height: 25vh;
}

.beecoin-icon-1 {
    position: relative;
    left: 3vw;
    top: 2vh;
    transform: rotate(15deg);
}

.beecoin-icon-2 {
    position: relative;
    bottom: 9vh;
    right: 4vw;
    z-index: 1;
}

@media (max-width: 1264px) {
    .row-card {
        height: 70vh;
    }

    .row-right-icon {
        height: 35vh;
    }

    .title-content {
        text-align: initial;
        margin-top: 5%;
        margin-bottom: 5%;
        font-size: 6vw;
        color: #514773;
    }

    .container-text-1 {
        width: 50vw;
    }

    .container-text-2 {
        width: 50vw;
    }

    .container-text-3 {
        width: 50vw;
    }

    .text-content {
        text-align: initial;
        margin-bottom: 50px;
        font-size: 4vw;
        color: #514773;
    }

    .button-next-1-text {
        color: white;
        font-size: 4vw;
        margin-bottom: 0;
    }

    .button-next-2-text-1 {
        color: white;
        font-size: 3vw;
        margin-bottom: 0;
    }

    .button-next-2-text-2 {
        color: #ff6f3a;
        font-size: 3vw;
        margin-bottom: 0;
    }

    .button-3 {
        text-transform: none;
        font-size: 2.5vw;
        font-weight: bold;
        margin-top: -8vh;
    }

    .number-icon-card {
        color: #ff6f3a;
        font-size: 6vw;
    }

    .beecoin-icon-1 {
        position: relative;
        left: 3vw;
        top: 11vh;
        transform: rotate(15deg);
    }

    .beecoin-icon-2 {
        position: relative;
        bottom: 0;
        right: 22vw;
        z-index: 1;
    }
}
</style>
